import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import CareplanSummary from './careplan_list/CareplanSummary';
import GeneralInformation from './careplan_list/GeneralInformation';
import MedicalHistory from './careplan_list/MedicalHistory';
import CareRoutine from './careplan_list/CareRoutine';
import CaregiverRequirements from './careplan_list/CaregiverRequirements';
import ReplacementPreference from './careplan_list/ReplacementPreference';

// The careplan of a Loom lead. It follows the client view's careplan, but every section is
// view-only.
const Careplan = (props) => {
  const {clientCareplan} = props;

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={2}
    >
      <CareplanSummary
        careplanSummary={clientCareplan.caregiverRequirements?.careplanSummary}
      />
      <GeneralInformation
        generalInformation={clientCareplan.generalInformation}
      />
      <MedicalHistory
        medicalHistory={clientCareplan.medicalHistory}
      />
      <CareRoutine
        careRoutine={clientCareplan.careRoutine}
      />
      <CaregiverRequirements
        caregiverRequirements={clientCareplan.caregiverRequirements}
      />
      <ReplacementPreference
        replacementPreference={clientCareplan.replacementPreference}
      />
    </Stack>
  );
};

Careplan.propTypes = {
  clientCareplan: PropTypes.object.isRequired,
};

export default Careplan;
